import {useRef} from 'react';

import {useOnMount} from 'shared/web';

import type {CheckoutProfileIssue} from '../../../utils/getCheckoutProfileIssueMessage';
import {focusCheckoutProfileIssue} from '../utils/focusCheckoutProfileIssue';

export function CheckoutProfileIssueFocus(props: {issue: CheckoutProfileIssue}) {
  const observer = useRef<MutationObserver>(undefined);
  useOnMount(
    () => {
      observer.current = new MutationObserver(() => {
        if (focusCheckoutProfileIssue(props.issue)) {
          observer.current?.disconnect();
        }
      });

      observer.current.observe(document.body, {childList: true, subtree: true});

      if (focusCheckoutProfileIssue(props.issue)) {
        observer.current.disconnect();
      }
    },
    () => observer.current?.disconnect()
  );

  return null;
}
